var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCurlRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80.07 10.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#a16a38;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Curl Right") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Colour_-_Dark",
    "data-name": "Colour - Dark"
  }, /*#__PURE__*/React.createElement("path", {
    id: "On",
    className: "cls-1",
    d: "M3.12,1.37a21.78,21.78,0,0,0,9,2.46C26.64,4.89,41.78-1,56.9.14,68.67,1,76.44,5.08,79.78,8.75c1.14,1.29-1.37,2.31-2.82,1.4C75.1,9,70.92,6.7,62.49,6.08,46.4,4.91,33.61,11,19.29,10c-9.7-.7-16-3.88-19-7.21C-.83,1.48,1.51.44,3.12,1.37Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurlRight);
export default __webpack_public_path__ + "static/media/curl_right.7b3fb9a8c0af5b75959f7b53de029886.svg";
export { ForwardRef as ReactComponent };